import { render, staticRenderFns } from "./ReviewDecisionPanel.vue?vue&type=template&id=0756a119&scoped=true&"
import script from "./ReviewDecisionPanel.vue?vue&type=script&lang=js&"
export * from "./ReviewDecisionPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReviewDecisionPanel.vue?vue&type=style&index=0&id=0756a119&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0756a119",
  null
  
)

export default component.exports